


export class InvoiceChildComponents
{
    contInvoiceList:number=1;
    contInvoiceAdd:number=2;
    contInvoiceEdit:number=3;
    contInvoiceView:number=4;
}